import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

type CardSize = 'small' | 'medium' | 'unset';

type CardProps = {
  title?: string;
  subtitle?: string;

  size?: CardSize;
  border?: string | boolean;
  children: React.ReactNode;
  actions?: React.ReactNode[];

  withOverflow?: boolean;

  className?: string;
  headerClassName?: string;
  contentClassName?: string;
};

const sizes: { [x in CardSize]: string } = {
  unset: '',
  small: 'w-[20rem]',
  medium: 'w-[48rem]',
};

export const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  children,
  size = 'medium',
  border = 'border shadow-sm',

  className,
  headerClassName,
  contentClassName,

  actions,
  withOverflow = true,
}) => {
  const hasTitle = !!title?.length || !!subtitle?.length || actions?.length;

  return (
    <div
      className={twMerge(
        clsx(border, sizes[size], withOverflow ? 'max-h-screen' : ''),
        'flex flex-col bg-contrast rounded-card p-lg',
        className
      )}
    >
      {hasTitle && (
        <div
          className={clsx(headerClassName, 'flex justify-between items-center')}
        >
          <div className="flex flex-col gap-y-sm">
            {!!title?.length && (
              <div className="text-big font-semibold text-mainText">
                {title}
              </div>
            )}
            {!!subtitle?.length && (
              <div className="text-small font-normal text-secondary">
                {subtitle}
              </div>
            )}
          </div>
          <div className="shrink-0 flex gap-x-md">{actions}</div>
        </div>
      )}
      <div
        className={clsx(
          contentClassName,
          'flex-grow',
          hasTitle ? 'mt-sm' : '',
          withOverflow ? 'overflow-y-auto' : ''
        )}
      >
        {children}
      </div>
    </div>
  );
};
